import { createAction, props } from '@ngrx/store';

// Terminals
export const requestTerminals = createAction('[Terminal Selection] Request Terminals');
export const loadTerminals = createAction(
    '[Location Context Effects] Load Terminals',
    props<{ terminals: string[] }>()
);

// Centerline Groups
export const requestCenterlineGroups = createAction(
    '[Terminal Selection] Request Centerline Group',
    props<{ selectedTerminal: string }>()
);
export const loadCenterlineGroups = createAction(
    '[Location Context Effects] Load Centerline Group',
    props<{ centerlineGroups: string[] }>()
);

// Centerlines
export const requestCenterlines = createAction(
    '[Terminal Selection] Request Centerlines',
    props<{ selectedCenterlineGroup: string }>()
);
export const loadCenterlines = createAction(
    '[Location Context Effects] Load Centerlines',
    props<{ centerlines: string[] }>()
);

// Reset
export const resetLocationContextData = createAction('[Location Context] Reset Data');
